var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import logo from "../assets/logo.png";
// import add from "../assets/icons/add-white.svg";
import NewOrderForm from "../Components/NewOrderForm";
import ProductsTable from "../Components/OrdersTable";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { ordersConstants } from "../store/actions/types";
import { getOrders, searchOrders } from "../utils/ordersApi";
import closeIcon from "../assets/icons/close.svg";
import profileIcon from "../assets/icons/profile.svg";
import settingsIcon from "../assets/icons/settings.svg";
import GenerateQuotationForm from "../Components/generateQuotationModal";
import { useHistory } from "react-router-dom";
import { makeSessionRequest } from "../utils/makeSessionRequest";
import { getIsSuperAdmin } from "../utils/getIsSuperAdmin";
import ProfileSettingsForm from "../Components/ProfileSettingsForm";
import { getUserFromLocalStorage } from "../utils/localStorage";
export default function Dashboard() {
    const [showNewOrderForm, setShowNewOrderForm] = useState(false);
    const [currentOrder, setCurrentOrder] = useState(null);
    const dispatch = useAppDispatch();
    const orders = useAppSelector((state) => state.orders.orders);
    const user = useAppSelector((state) => state.user);
    const loadingOrders = useAppSelector((state) => state.orders.loadingOrders);
    const currentPage = useAppSelector((state) => state.orders.currentPage);
    const pageSize = useAppSelector((state) => state.orders.pageSize);
    const totalOrders = useAppSelector((state) => state.orders.totalOrders);
    const [searchText, setSearchText] = useState("");
    const searchedOrders = useAppSelector((state) => state.orders.searchedOrders);
    const [isSearched, setIsSearched] = useState(false);
    const [showGenerateQuotationForm, setShowGenerateQuotationForm] = useState(false);
    const [showBomDownloadForm, setShowBomDownloadForm] = useState(false);
    const [showProfileSettings, setShowProfileSettings] = useState(false);
    const [showDealerSettings, setShowDealerSettings] = useState(false);
    const history = useHistory();
    useEffect(() => {
        makeSessionRequest("dashboard_view");
        const superAdmin = getIsSuperAdmin();
        const user = getUserFromLocalStorage();
        if (superAdmin || (user && user.role === 2)) {
            setShowDealerSettings(true);
        }
    }, []);
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            try {
                dispatch({ type: ordersConstants.SET_LOADING_ORDERS, payload: true });
                const orders = (yield getOrders(currentPage, pageSize)) || [];
                dispatch({ type: ordersConstants.SET_ORDERS, payload: orders._items });
                dispatch({
                    type: ordersConstants.SET_TOTAL_ORDERS,
                    payload: orders.totalOrders,
                });
                dispatch({ type: ordersConstants.SET_LOADING_ORDERS, payload: false });
            }
            catch (error) {
                console.error(error, "ERROR");
                toast.error("Failed to fetch orders");
                dispatch({ type: ordersConstants.SET_LOADING_ORDERS, payload: false });
            }
        }))();
    }, [dispatch, user.id, user.role, currentPage, pageSize, totalOrders]);
    const onSearchOrders = (searchText) => __awaiter(this, void 0, void 0, function* () {
        setIsSearched(true);
        makeSessionRequest("searched_orders", { searchText });
        if (searchText) {
            try {
                dispatch({
                    type: ordersConstants.SET_LOADING_ORDERS,
                    payload: true,
                });
                const orders = yield searchOrders(searchText);
                if (orders._items.length === 0) {
                    toast.error(`No orders found for ${searchText}`);
                    dispatch({
                        type: ordersConstants.SET_LOADING_ORDERS,
                        payload: false,
                    });
                    setIsSearched(false);
                    return;
                }
                else {
                    dispatch({
                        type: ordersConstants.SET_SEARCHED_ORDERS,
                        payload: orders._items,
                    });
                    dispatch({
                        type: ordersConstants.SET_TOTAL_ORDERS,
                        payload: orders.totalOrders,
                    });
                    dispatch({
                        type: ordersConstants.SET_LOADING_ORDERS,
                        payload: false,
                    });
                }
            }
            catch (error) {
                toast.error("Failed to search orders");
                dispatch({
                    type: ordersConstants.SET_LOADING_ORDERS,
                    payload: false,
                });
            }
        }
    });
    const clearSearch = () => {
        setIsSearched(false);
        setSearchText("");
        dispatch({
            type: ordersConstants.SET_SEARCHED_ORDERS,
            payload: [],
        });
    };
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            if ((searchText === "" || !searchText) && searchedOrders.length > 0) {
                clearSearch();
            }
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, searchText, searchedOrders]);
    const logout = () => {
        makeSessionRequest("user_logged_out");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userTags");
        dispatch({ type: "LOGOUT", payload: {} });
        window.location.reload();
    };
    const closeNewOrderForm = () => {
        setShowNewOrderForm(false);
    };
    const editOrder = (order) => {
        makeSessionRequest("clicked_edit_order", { orderId: order._id });
        setCurrentOrder(order);
        setShowNewOrderForm(true);
    };
    return (_jsxs("div", Object.assign({ className: "pb-16" }, { children: [_jsx(NewOrderForm, { show: showNewOrderForm, closeNewOrderForm: closeNewOrderForm, currentOrder: currentOrder }), _jsx(GenerateQuotationForm, { show: showGenerateQuotationForm, closeForm: () => setShowGenerateQuotationForm(false) }), _jsx(ProfileSettingsForm, { show: showProfileSettings, closeForm: () => setShowProfileSettings(false) }), _jsxs("div", Object.assign({ className: "flex items-center py-4 px-8" }, { children: [_jsx("img", { src: logo, className: " w-62 h-auto", alt: "" }), _jsxs("div", Object.assign({ className: " ml-8 md:ml-auto flex justify-center" }, { children: [_jsx("button", Object.assign({ onClick: () => setShowProfileSettings(true), className: "bg-500 px-4 py-2 mr-5 tracking-wider text-white xl:text-xl", style: { backgroundColor: "#e41b23" } }, { children: _jsx("img", { src: profileIcon, className: "w-6 h-6", alt: "" }) })), _jsx("button", Object.assign({ onClick: () => {
                                    makeSessionRequest("clicked_settings");
                                    history.push("/settings");
                                }, className: ` bg-500 px-4 py-2 mr-5 tracking-wider text-white xl:text-xl ${showDealerSettings ? "" : "hidden"}`, style: { backgroundColor: "#e41b23" } }, { children: _jsx("img", { src: settingsIcon, className: "w-6 h-6", alt: "" }) })), _jsx("button", Object.assign({ onClick: logout, className: "bg-500 px-4 py-2 tracking-wider text-white xl:text-xl", style: { backgroundColor: "#e41b23" } }, { children: "Logout" }))] }))] })), _jsxs("div", Object.assign({ style: { maxWidth: "1800px" }, 
                // style={{ width: "max-content" }}
                className: "xs:px-16 px-2 2xl:px-16 xl:px-10 mt-8 ml-auto mr-auto" }, { children: [_jsxs("div", Object.assign({ className: "flex items-center mb-8 w-full" }, { children: [(orders === null || orders === void 0 ? void 0 : orders.length) > 0 && (_jsx("h3", Object.assign({ className: "text-xl xl:text-2xl font-bold" }, { children: "Quotations:" }))), (orders === null || orders === void 0 ? void 0 : orders.length) > 0 && (_jsxs("div", Object.assign({ className: "flex justify-between border transition-all ml-auto mr-auto", style: { width: "30rem" } }, { children: [_jsx("input", { type: "text", value: searchText, onChange: (e) => {
                                            setSearchText(e.target.value);
                                        }, placeholder: "Enter search text", className: "focus:outline-none w-full px-4" }), _jsxs("div", Object.assign({ className: "flex items-center relative" }, { children: [searchText && (_jsx("img", { src: closeIcon, alt: "clear", className: "absolute -left-8 z-index-10", onClick: () => {
                                                    makeSessionRequest("search_cleared");
                                                    clearSearch();
                                                } })), _jsx("span", Object.assign({ className: "bg-500 px-2 py-2 text-white xl:text-xl min-w-max cursor-pointer", style: { backgroundColor: "#e41b23" }, onClick: () => onSearchOrders(searchText) }, { children: "search" }))] }))] }))), _jsx("button", Object.assign({ onClick: () => {
                                    setCurrentOrder(null);
                                    setShowNewOrderForm(true);
                                    makeSessionRequest("clicked_on_create_quotation");
                                }, className: "ml-auto bg-500 px-2 py-2 tracking-wider text-white xl:text-xl min-w-max", style: { backgroundColor: "#e41b23" } }, { children: "ADD NEW CUSTOMER" }))] })), (orders === null || orders === void 0 ? void 0 : orders.length) === 0 ||
                        (isSearched && (searchedOrders === null || searchedOrders === void 0 ? void 0 : searchedOrders.length) === 0) ? (loadingOrders ? (_jsx("div", Object.assign({ className: "text-center mt-2 font-bold" }, { children: "Loading Data..." }))) : (_jsx("div", Object.assign({ className: "text-center mt-2 font-bold" }, { children: "No orders" })))) : (_jsx(ProductsTable, { editOrder: editOrder, showGenerateQuotationForm: () => setShowGenerateQuotationForm(true), showBomDownloadForm: () => setShowBomDownloadForm(true) }))] }))] })));
}
